
const configUrl = {
    development: 'https://portal-admin-develop.kapeixi.cn',
    release: 'https://portal-admin-release.kapeixi.cn',
    preview: 'https://portal-admin-pre.kapeixi.cn',
    aws: 'https://aws-portal-admin.kapeixi.cn',
    production: 'https://portal-admin.cupshe.com'
}

const getQueryString = (variable) => {
    let href = window.location.href
    let query = href.substring(href.indexOf('?') + 1)
    let vars = query.split('&')
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split('=')
        if (pair[0] === variable) {
            return pair[1]
        }
    }
    return false
}

export const getRootData = async (option) => {

    const nodeENV = option.env || getQueryString('env')

    const domain =  option.domain ||  configUrl[nodeENV]

    const response = await fetch(`${domain}/portal/menu/query/button/${option.systemId}`, {
        headers: {
            'Authorization': localStorage.getItem('token')
        }
    }).then(response => response)
    const { data, success } = await response.json()
    try {
        if (success) {
            return data
        } else {
            return {}
        }
    } catch (error) {
        return {}
    }
}

